// OptionsDatesForm.jsx
import { useState } from "react"
import { Grid } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * Options Dates Form is a group of data inputs usually shown when clicking on Options->Dates. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @returns UI for interactive swmm modeling.
 */
export default function OptionsDatesForm({model, setModel, fullModel}) {
  const [startAnalysisDate, setStartAnalysisDate] = useState(
    fullModel.OPTIONS.START_DATE?(
      fullModel.OPTIONS.START_DATE.split('/')[2] + '-' +
      fullModel.OPTIONS.START_DATE.split('/')[0] + '-' +
      fullModel.OPTIONS.START_DATE.split('/')[1])
    :'')
  
  const [startReportDate, setStartReportDate] = useState(
    fullModel.OPTIONS.REPORT_START_DATE?(
      fullModel.OPTIONS.REPORT_START_DATE.split('/')[2] + '-' +
      fullModel.OPTIONS.REPORT_START_DATE.split('/')[0] + '-' +
      fullModel.OPTIONS.REPORT_START_DATE.split('/')[1])
    :'')

    const [endAnalysisDate, setEndAnalysisDate] = useState(
      fullModel.OPTIONS.END_DATE?(
        fullModel.OPTIONS.END_DATE.split('/')[2] + '-' +
        fullModel.OPTIONS.END_DATE.split('/')[0] + '-' +
        fullModel.OPTIONS.END_DATE.split('/')[1])
      :'')
    
    const [startAnalysisTime, setStartAnalysisTime] = useState(fullModel.OPTIONS.START_TIME       ?fullModel.OPTIONS.START_TIME       :'00:00:00')
    const [endAnalysisTime,   setEndAnalysisTime]   = useState(fullModel.OPTIONS.END_TIME         ?fullModel.OPTIONS.END_TIME         :'00:00:00')
    const [startReportTime,   setStartReportTime]   = useState(fullModel.OPTIONS.REPORT_START_TIME?fullModel.OPTIONS.REPORT_START_TIME:'00:00:00')
    
    const [startSweepDate, setStartSweepDate] = useState(fullModel.OPTIONS.SWEEP_START?fullModel.OPTIONS.SWEEP_START:'01/01')
    const [endSweepDate,   setEndSweepDate]   = useState(fullModel.OPTIONS.SWEEP_END  ?fullModel.OPTIONS.SWEEP_END  :'12/31')
    const [dryDays,        setDryDays]        = useState(fullModel.OPTIONS.DRY_DAYS   ?fullModel.OPTIONS.DRY_DAYS   :'0')

  const updateStartAnalysisDate = (val) => {
    setStartAnalysisDate(val)
    
    let stringDate = 
    val.split('-')[1] + '/' +
    val.split('-')[2] + '/' +
    val.split('-')[0]

    if(model){
      setModel(prev => ({
        ...prev,
        OPTIONS:{
          ...prev.OPTIONS,
          START_DATE: stringDate
        }
      }))
    }
  }

  const updateStartReportDate = (val) => {
    setStartReportDate(val)
    
    let stringDate = 
    val.split('-')[1] + '/' +
    val.split('-')[2] + '/' +
    val.split('-')[0]

    if(model){
      setModel(prev => ({
        ...prev,
        OPTIONS:{
          ...prev.OPTIONS,
          REPORT_START_DATE: stringDate
        }
      }))
    }
  }
  
  const updateEndAnalysisDate = (val) => {
    setEndAnalysisDate(val)
    
    let stringDate = 
    val.split('-')[1] + '/' +
    val.split('-')[2] + '/' +
    val.split('-')[0]

    if(model){
      setModel(prev => ({
        ...prev,
        OPTIONS:{
          ...prev.OPTIONS,
          END_DATE: stringDate
        }
      }))
    }
  }

  const updateStartAnalysisTime = (val) => {
    setStartAnalysisTime(val)
    
    if(model){
      setModel(prev => ({
        ...prev,
        OPTIONS:{
          ...prev.OPTIONS,
          START_TIME: val
        }
      }))
    }
  }
  
  const updateStartReportTime = (val) => {
    setStartReportTime(val)
    
    if(model){
      setModel(prev => ({
        ...prev,
        OPTIONS:{
          ...prev.OPTIONS,
          REPORT_START_TIME: val
        }
      }))
    }
  }
  
  const updateEndAnalysisTime = (val) => {
    setEndAnalysisTime(val)
    
    if(model){
      setModel(prev => ({
        ...prev,
        OPTIONS:{
          ...prev.OPTIONS,
          END_TIME: val
        }
      }))
    }
  }
  
  
  const updateStartSweepDate = (val) => {
    setStartSweepDate(val)
    if(model){
      setModel(prev => ({
        ...prev,
        OPTIONS:{
          ...prev.OPTIONS,
          SWEEP_START: val
        }
      }))
    }
  }
  
  const updateEndSweepDate = (val) => {
    setEndSweepDate(val)
    if(model){
      setModel(prev => ({
        ...prev,
        OPTIONS:{
          ...prev.OPTIONS,
          SWEEP_END: val
        }
      }))
    }
  }
  
  const updateDryDays = (val) => {
    setDryDays(val)
    if(model){
      setModel(prev => ({
        ...prev,
        OPTIONS:{
          ...prev.OPTIONS,
          DRY_DAYS: val
        }
      }))
    }
  }

  return(
    <>
    {
      <>
      <Grid container>
        <Grid item xs={6}>
        {(
          <>
          <label className='editor-small' >Start Analysis on
            <input  type = "date"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{updateStartAnalysisDate(e.target.value)}}
                    value={startAnalysisDate}
                    id={'OptionsStartAnalysisDate'}
            />
          </label>
          <label className='editor-small' >Start Reporting on
            <input  type = "date"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{updateStartReportDate(e.target.value)}}
                    value={startReportDate}
                    id={'OptionsStartReportDate'}
            />
          </label>
          <label className='editor-small' >End Analysis on
            <input  type = "date"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{updateEndAnalysisDate(e.target.value)}}
                    value={endAnalysisDate}
                    id={'OptionsEndAnalysisDate'}
            />
          </label>
          <label className='editor-small' >Start Sweeping on
            <input  type = "text"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{updateStartSweepDate(e.target.value)}}
                    value={startSweepDate}
                    id={'OptionsStartSweep'}
            />
          </label>
          <label className='editor-small' >End Sweeping on
            <input  type = "text"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{updateEndSweepDate(e.target.value)}}
                    value={endSweepDate}
                    id={'OptionsEndSweep'}
            />
          </label>
          <label className='editor-small' >Antecedent Dry Days
            <input  type = "text"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{updateDryDays(e.target.value)}}
                    value={dryDays}
                    id={'OptionsDryDays'}
            />
          </label>
          </>
        )}
        </Grid>
        <Grid item xs={6}>
        {(
          <>
          <label className='editor-small' >Start Analysis time
            <input  type = "time"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{updateStartAnalysisTime(e.target.value)}}
                    value={startAnalysisTime}
                    id={'OptionsStartAnalysisTime'}
            />
          </label>
          <label className='editor-small' >Start Reporting time
            <input  type = "time"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{updateStartReportTime(e.target.value)}}
                    value={startReportTime}
                    id={'OptionsStartReportTime'}
            />
          </label>
          <label className='editor-small' >End Analysis time
            <input  type = "time"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{updateEndAnalysisTime(e.target.value)}}
                    value={endAnalysisTime}
                    id={'OptionsEndAnalysisTime'}
            />
          </label>
          </>
        )}
        </Grid>
      </Grid>
      </>
    }
    </>
  )
} 